// @flow

import type { BuildPlatform } from '../types/flow/BuildPlatform';

export default ([
  'ios',
  'macos',
  'node',
]: BuildPlatform[]);
